'use client';

import { useEffect } from 'react';

import { ALL_TOOLS } from '@/lib/unified-tools';

interface UsageTrackerProps {
    title: string;
    path: string;
}

const UsageTracker = ({ title, path }: UsageTrackerProps) => {
    useEffect(() => {
        if (typeof window !== 'undefined' && title && path) {
            // Find icon from our unified registry
            const toolFromRegistry = ALL_TOOLS.find(t => 
                t.title === title || 
                t.href === path || 
                t.href === `/${path}` ||
                path.includes(t.href)
            );

            const currentTool = {
                name: title,
                href: path.startsWith('/') ? path : `/${path}`,
                icon: toolFromRegistry ? '🛠️' : '🛠️' // Fallback to emoji for localstorage string
            };

            // Note: Since ALL_TOOLS uses React nodes for icons, we can't easily store them in localStorage.
            // RecentlyUsed.tsx will handle the icon display.

            const stored = localStorage.getItem('recently_used_tools');
            let recent = stored ? JSON.parse(stored) : [];

            recent = [currentTool, ...recent.filter((t: any) => t.href !== currentTool.href)].slice(0, 8);
            localStorage.setItem('recently_used_tools', JSON.stringify(recent));
        }
    }, [title, path]);

    return null;
};

export default UsageTracker;
